import { render, staticRenderFns } from "./TaskUpdateOwner.vue?vue&type=template&id=20fe0534&scoped=true"
import script from "./TaskUpdateOwner.vue?vue&type=script&lang=js"
export * from "./TaskUpdateOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fe0534",
  null
  
)

export default component.exports